import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { GridModule, ResizeService } from '@syncfusion/ej2-angular-grids';
import { MyDatePickerModule } from 'mydatepicker';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { ClientParentModule } from '../client-parent/client-parent.module'
import { PageService, SortService, FilterService, GroupService } from '@syncfusion/ej2-angular-grids';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { dropdownModule } from 'src/app/dropdown/dropdown.module';
import { TicketComponent } from './ticket.component';
import { TicketRoutingModule } from './ticket-routing.module';
import { TicketViewComponent } from './ticket-view/ticket-view.component';
import { TicketEntryComponent } from './ticket-entry/ticket-entry.component';
import { ChatUiModule } from '../engagement/chat-history/chat-history.module';

@NgModule({
  declarations: [TicketComponent, TicketViewComponent, TicketEntryComponent],
  imports: [
    TicketRoutingModule,
    CommonModule,
    PdfViewerModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    GridModule,
    ToolbarModule,
    DropDownListAllModule,
    MyDatePickerModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    dropdownModule,
    ChatUiModule
    
  ],
  providers: [PageService,
    SortService,
    ResizeService,
    FilterService,
    GroupService],
  exports: [TicketComponent , TicketViewComponent, TicketEntryComponent]
})
export class TicketModule { }
